/** API route map: URLS.Controller.Job */
export const Job = {
      Name: 'Job/',
      AddJob: 'add-job',
      GetClientListByName: 'get-Client-list-by-name',
      GetAll: 'jobs',
      GetAllPublishedJobs: 'publish-jobs',
      Tiles: 'tiles',
      UpdateJob: 'patch-job',
      GetJobSummary: 'get-job-header-summary',
      SearchJobs: 'search-jobs',
      GetClientById: 'get-Client-by-id',
      GetJobNameById: 'get-job-name-by-id',
      GetAllJobCandidate: 'job-candidates',
      GetAllMultiStatusCandidate: 'multi-status-candidate',
      GetAllDropJobCandidate: 'drop-job-candidates',
      GetAllJobCandidateExport: 'job-candidates-export',
      GetJobCandidateTiles: 'tiles',
      AddJobCandidate: 'add-job-candidate',
      PublishUnPublishJob: 'publish-unpublish-job',
      GetJobByGUId: 'get-job-by-id',
      GetJobByjobId: 'get-job-by-jobId',
      AddJobPublish: 'add-bulk-job-publish',
      GetJobBadgesBulk: 'get-badges-for-bulk-job',
      AddJobBulkBadges: 'add-job-bulk-badge',
      AddJobBulkStatus: 'add-bulk-job-status',
      ClientJobs: 'get-client-jobs',
      ClientJobsSearch: 'search-jobs-client',
      UpdateCurrentJob: 'update-job',
      GetJobLogs: 'get-job-logs',
      AddJobDescription: 'add-description',
      SearchPublishJobs: 'search-publish-jobs',
      GetAllJobsBoardView: 'jobs-board-view',
      PatchBillingDetails: 'patch-billing',
      GetAllJobCandidateBoardView: 'job-candidates-board-view',
      GetJobSkills: 'get-job-skills',
      GetJobDetailsById: 'get-job-details-by-id',
};
